/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum MachineState {
  Unknown = 'Unknown',
  Idle = 'Idle',
  Setup = 'Setup',
  Run = 'Run',
  Downtime = 'Downtime',
  ManualMachine = 'ManualMachine'
}
